import { Box } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'components/general/Link';
import Slider from 'components/general/Slider';

import { cdnURL } from '@inspire/util/cdn';

const partners = [
  {
    name: "À vous le sup' - HDF",
    url: 'https://avouslesup.univ-lille.fr/',
    imageUrl: cdnURL('/a-vous-le-sup.png'),
  },
  {
    name: 'BNP',
    url: 'https://group.bnpparibas/',
    imageUrl: cdnURL('/bnp.jpg'),
  },
  {
    name: 'Citizen',
    url: 'https://www.citizencapital.fr/',
    imageUrl: cdnURL('/citizen-capital.png'),
  },
  {
    name: 'Crédit Agricole Martinique Guyane',
    url: 'https://www.credit-agricole.fr/ca-martinique/particulier.html',
    imageUrl: cdnURL('/CAMG.jpg'),
  },
  {
    name: 'FAGE',
    url: 'https://www.fage.org/',
    imageUrl: cdnURL('/7003-fage1.png'),
  },
  {
    name: 'Fondation HEC',
    url: 'http://www.fondationhec.fr/',
    imageUrl: cdnURL('/2431-fondationhec.png'),
  },
  {
    name: 'FSE AURA',
    url: 'https://fse.gouv.fr/le-fse-en-auvergne-rhone-alpes',
    imageUrl: cdnURL('/Region-Auvergne-Rhone-Alpes.png'),
  },
  {
    name: 'Je Veux Aider',
    url: 'https://www.jeveuxaider.gouv.fr/',
    imageUrl: cdnURL('/3712-logo_jva_gouv_carre_light.png'),
  },
  {
    name: 'Les cordées de la réussite',
    url: 'https://www.cordeesdelareussite.fr/',
    imageUrl: cdnURL('/logo-cordees-de-la-reussite.jpg'),
  },
  {
    name: 'MESR',
    url: 'http://www.enseignementsup-recherche.gouv.fr/',
    imageUrl: cdnURL(
      '/ministere-de-l-enseignement-superieur-et-de-la-recherche.jpg'
    ),
  },
  {
    name: 'Ministère du travail',
    url: 'https://travail-emploi.gouv.fr/',
    imageUrl: cdnURL('/ministere-travail-sante-solidarites-famille-2025.png'),
  },
  {
    name: "Ministre de l'Agriculture et de la Souveraineté alimentaire",
    url: 'https://agriculture.gouv.fr/',
    imageUrl: cdnURL('/MASA.png'),
  },
  {
    name: 'ONISEP',
    url: 'http://www.onisep.fr/',
    imageUrl: cdnURL('/6093-onisep.jpg'),
  },
  {
    name: 'MOEL',
    url: 'http://www.monorientationenligne.fr/inspire',
    imageUrl: cdnURL('/2258-moel.png'),
  },
  {
    name: 'Plateforme Avenir(s)',
    url: 'https://www.onisep.fr/avenir-s',
    imageUrl: cdnURL('/programme-avenirs.png'),
  },
  {
    name: 'Région académique HDF',
    imageUrl: cdnURL('/Région_Hauts-de-France.png'),
    url: 'https://www1.ac-lille.fr/la-region-academique-hauts-de-france-121434',
  },
  {
    name: 'Région Hauts-de-France',
    imageUrl: cdnURL('/9274-hdf.jpg'),
    url: 'https://www.hautsdefrance.fr/',
  },
  {
    name: 'Région IDF',
    imageUrl: cdnURL('/region-idf.jpg'),
    url: 'https://www.iledefrance.fr/',
  },
];

const PartnersSlider = ({ isMobile = false }) => {
  const settings = {
    autoPlay: true,
    autoPlaySpeed: 1000,
    infinite: true,
    slidesToShow: 4,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 900, settings: { slidesToShow: 3 } },
      { breakpoint: 650, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <Slider settings={settings} isMobile={isMobile}>
      {partners.map((p, i) => {
        return (
          <Box key={i}>
            {p.url ? (
              <Link key={i} href={p.url} target="_blank">
                <Box
                  maxW="90%"
                  m={['10px', '20px', '30px']}
                  height={isMobile ? '200px' : '80px'}
                  pos="relative"
                >
                  <Image
                    src={p.imageUrl}
                    alt={p.name}
                    layout="fill"
                    objectFit="contain"
                  />
                </Box>
              </Link>
            ) : (
              <Box
                maxW="90%"
                m={['10px', '20px', '30px']}
                height="80px"
                pos="relative"
              >
                <Image
                  src={p.imageUrl}
                  alt={p.name}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Slider>
  );
};

export default PartnersSlider;
